'use strict';

require('./cn-questionnaire-wizard.scss');

module.exports = {
  template: require('./cn-questionnaire-wizard.html'),
  controller: require('./cn-questionnaire-wizard.controller'),
  controllerAs: 'vm',

  bindings: {
    current: '<',
    max: '<',
    onChange: '&',
    answers: '<',
    locked: '<',
    hideCompleted: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-questionnaire-wizard/index.js
 ** module id = 105
 ** module chunks = 0
 **/